import { BaseOwnerEntity } from "../baseOwnerEntity";

export class CashRegisterEntity extends BaseOwnerEntity {
  id?: number;
  storeId?: number;
  name?: string;
  status?: number;
  vendorType?: string;
  apiUrl?: string;
  userName?: string;
  password?: string;
  merchantKey?: string;
  secretKey?: string;
  isSendConfiguration?: boolean;
  deviceCode?: string;
  deviceInfoData?: string;
  transactionSequence?: number;
  accessToken?: string;
  tokenExpiryDate?: Date;
  connectionType?: string;
  vendorSettings?: string;
  integrationExpiryDate?: Date;
  environmentMode?: string;
}